import reduce from 'lodash/fp/reduce'


const fields = {
    API: {
        isRequired: false,
        text: 'APIs',
        value: 'api'
    },
    COMPANY_NAME: {
        isRequired: true,
        text: 'Company Name',
        value: 'companyName'
    },
    COUNTRY_CODE: {
        isRequired: true,
        text: 'Country Code',
        value: 'countryCode'
    },
    EMAIL: {
        isRequired: true,
        text: 'Email',
        value: 'email'
    },
    EQUITIES: {
        isRequired: false,
        text: 'Equities',
        value: 'equities'
    },
    EXT: {
        isRequired: false,
        text: 'Ext',
        value: 'ext'
    },
    FIRST_NAME: {
        isRequired: true,
        text: 'First Name',
        value: 'firstName'
    },
    FUTURES: {
        isRequired: false,
        text: 'Futures',
        value: 'futures'
    },
    FX: {
        isRequired: false,
        text: 'FX',
        value: 'fx'
    },
    INDEX_ANALYTICS: {
        isRequired: false,
        text: 'Index Analytics',
        value: 'indexAnalytics'
    },
    INTERESTED_IN: {
        isRequired: false,
        text: 'Interested In',
        value: 'interestedIn'
    },
    LANGUAGE: {
        isRequired: true,
        text: 'Preferred language',
        value: 'preferredLanguage'
    },
    LAST_NAME: {
        isRequired: true,
        text: 'Last Name',
        value: 'lastName'
    },
    PHONE_NUMBER: {
        isRequired: true,
        text: 'Phone Number',
        value: 'phoneNumber'
    }
}


export const initialValues = reduce((acc, field) => {
    const defaultVal = ''
    return {
        ...acc,
        [field]: defaultVal,
        [fields.INTERESTED_IN]: [],
    }
}, {}, Object.values(fields).map(rec => rec.value))

export default fields
